import { render, staticRenderFns } from "./dialog-task.vue?vue&type=template&id=150f3c91&"
import script from "./dialog-task.vue?vue&type=script&lang=js&"
export * from "./dialog-task.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports